import { render, staticRenderFns } from "./_PowerPlans.vue?vue&type=template&id=6712d22a&scoped=true&"
import script from "./_PowerPlans.vue?vue&type=script&lang=ts&"
export * from "./_PowerPlans.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6712d22a",
  null
  
)

export default component.exports